interface LoaderProperties {
  // eslint-disable-next-line react/require-default-props
  className?: string;
}

export default function Loader({ className = '' }: LoaderProperties) {
  return (
    <div className={`${className} fixed inset-0 flex items-center justify-center`}>
      <div
        className="h-8 w-8 animate-spin rounded-full border-4 border-gray-200"
        style={{ borderTopColor: 'transparent' }}
      />
    </div>
  );
}
